export var getResolvedHostname = function getResolvedHostname(resolvedRegion, _a) {
  var regionHostname = _a.regionHostname,
    partitionHostname = _a.partitionHostname;
  return regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;
};